{
  "moreLikely": "More Likely",
  "lessLikely": "Less Likely",
  "yearCompletion": "Goal completion likely in ",
  "years": " {{years}} years",
  "adjustNote": "Adjust your initial and monthly contributions below to see updated projections",
  "frequency": "Frequency"
}
